import type React from 'react';
import { styled, useTheme } from 'styled-components';

import { Button } from '../../Controls/Button/index.tsx';
import Icons from '../../Elements/Icons/index.ts';
import { Modal } from './index.tsx';
import { Header, Wrapper } from './styled.ts';
import type { ModalProps } from './types.ts';

const StyledModal = styled(Modal)`
  min-height: 150px;
`;

const StyledHeader = styled(Header)`
  padding: 16px 16px 0;
  height: auto;

  && {
    border: 0;
  }
`;

export const ModalPlain: React.FC<ModalProps> = ({ children, ...props }) => {
  const theme = useTheme();
  return (
    <StyledModal width='400px' height='auto' shouldCloseOnOverlayClick {...props}>
      <Wrapper data-test='modal-window'>
        <StyledHeader>
          <div />
          <Button ghost iconOnly onClick={props.state.close} data-testid='close-button-modal-window'>
            <Icons.Close size={24} color={theme.colors.grey100_1} />
          </Button>
        </StyledHeader>
        {children}
      </Wrapper>
    </StyledModal>
  );
};
